module.exports = __webpack_public_path__ + "img/link-banner-cn.09b8d66e.png";